import React from 'react'
import { t } from 'ttag'

const AdmissionSection = ({ admissions }) => {
  if (!admissions) {
    return null
  }

  if (admissions.hasOwnProperty('policy')) {
    return (
      <div className="section admissions-section sections">
        <h3>
          <span>{t`Admissions`}</span>
        </h3>
        <div>{admissions.policy}</div>
      </div>
    )
  }

  const toNum = (inp, endWith) => {
    if (!inp) {
      return 'n/a'
    }

    return inp.toLocaleString() + (endWith || '')
  }
  const data = () => {
    const admissionsYear = '2019'

    return (
      <div className="admission-info">
        <p className="instructions">{t`In ${admissionsYear}, the applicant pool for this institution was comprised of:`}</p>
        <table className="tbl application-table">
          <thead>
            <tr>
              <th>{t`Applicant Pool`}</th>
              <th>{t`Applications`}</th>
              <th>{t`Acceptances`}</th>
              <th
                title=""
                data-original-title="The percentage of applicants who are accepted to the institution">
                {t`Rate`}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="even">
              <td>{t`Men`}</td>
              <td className="men-applications">{toNum(admissions.menApplications)}</td>
              <td className="men-admissions">{toNum(admissions.menAdmissions)}</td>
              <td className="men-acceptance">{toNum(admissions.menAcceptance, '%')}</td>
            </tr>
            <tr className="odd">
              <td>{t`Women`}</td>
              <td className="women-applications">
                {toNum(admissions.womenApplications)}
              </td>
              <td className="women-admissions">{toNum(admissions.womenAdmissions)}</td>
              <td className="women-acceptance">
                {toNum(admissions.womenAcceptance, '%')}
              </td>
            </tr>
            <tr className="even totalrow">
              <td>{t`Total`}</td>
              <td className="total-applications">
                {toNum(admissions.totalApplications)}
              </td>
              <td className="total-admissions">{toNum(admissions.totalAdmissions)}</td>
              <td className="total-acceptance">
                {toNum(admissions.totalAcceptance, '%')}
              </td>
            </tr>
          </tbody>
        </table>
        <br />

        <table className="tbl admission-test-table">
          <thead>
            <tr>
              <th>{t`Test Type`}</th>
              <th
                title={t`Each test is usually broken up into multiple parts and scores are reported separately. The section types are shown in this column`}>
                {t`Score Type`}
              </th>
              <th
                title={t`Of the students who were accepted to this university, 3/4 of them (or 75%) had this score or higher`}>
                25%
              </th>
              <th
                title={t`Of the students who were accepted to this university, 1/4 of them (or 25%) had this score or higher`}>
                75%
              </th>
              <th
                title={t`Percentage of students who have submitted the particular test`}>
                {t`Population`}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="even">
              <td rowSpan="2">SAT</td>
              <td>{t`Math`}</td>
              <td className="sat-math-25">{admissions.satMathPercentile25}</td>
              <td className="sat-math-75">{admissions.satMathPercentile75}</td>
              <td rowSpan="2" className="sat-pct-submit" style={{ textAlign: 'center' }}>
                {toNum(admissions.satPctSubmitting, '%')}
              </td>
            </tr>
            <tr className="even">
              <td>{t`Evidence-Based Reading and Writing`}</td>
              <td className="sat-critical-reading-25">
                {admissions.satCriticalReadingPercentile25}
              </td>
              <td className="sat-critical-reading-75">
                {admissions.satCriticalReadingPercentile75}
              </td>
            </tr>
            <tr className="odd">
              <td rowSpan="3">ACT</td>
              <td className="bottomborder">{t`English`}</td>
              <td className="bottomborder act-english-25">
                {admissions.actEnglishPercentile25}
              </td>
              <td className="bottomborder act-english-75">
                {admissions.actEnglishPercentile75}
              </td>
              <td rowSpan="3" className="act-pct-submit" style={{ textAlign: 'center' }}>
                {toNum(admissions.actPctSubmitting, '%')}
              </td>
            </tr>
            <tr className="odd">
              <td className="bottomborder">{t`Math`}</td>
              <td className="bottomborder act-math-25">
                {admissions.actMathPercentile25}
              </td>
              <td className="bottomborder act-math-75">
                {admissions.actMathPercentile75}
              </td>
            </tr>
            <tr className="odd">
              <td>{t`Composite`}</td>
              <td className="act-composite-25">{admissions.actCompositePercentile25}</td>
              <td className="act-composite-75">{admissions.actCompositePercentile75}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="section admissions-section sections">
      <h3>
        <span>{t`Admissions`}</span>
      </h3>
      {admissions.hasOwnProperty('policy') ? admissions.policy : data()}
    </div>
  )
}

export default AdmissionSection
